import { Link, useNavigate, useParams } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { useState, useEffect } from 'react'
import {
  fetchPostById,
  removePost,
  toggleLike,
  updateHelpful,
} from '../../../store/slices/post.slice'
import { utilService } from '../../../services/util.service'
import toast from 'react-hot-toast'
import { articelsHomePageImages } from '../../../services/images.service'
import { PostDetailsHeader } from './PostDetailsHeader'
import { PostDetailsTitleAndDescription } from './PostDetailsTitleAndDescription'
import { PostDetailsMobileTop } from './PostDetailsMobileTop'
import { PostDetailsMobileFooter } from './PostDetailsMobileFooter'
import { PostDetailsMainContent } from './PostDetailsMainContent'
import { PostDetailsHelpfulSection } from './PostDetailsHelpfulSection'
import { Articles } from '../../HomePage/Articles'
import { CommentIndex } from '../../CommentSystem/CommentIndex'
import { openNotRegisteredPopup } from '../../../store/slices/ui.slice'
import { PostDetailsHelmet } from '../../Helments/PostDetailsHelmet'
import { PostForm } from '../../../pagesv2/post/PostForm'
import { Loader } from '../../FarmerMotion/Loader'

export const PostDetails = () => {
  const { postId } = useParams()
  const dispatch = useDispatch()
  const [isEditing, setIsEditing] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const navigate = useNavigate()

  const selectedPost = useSelector((state) => state.postModule.selectedPost)
  const loggedInUser = useSelector((state) => state.userModule.loggedInUser)

  const handleRemovePost = async (postId) => {
    if (!window.confirm('האם אתה בטוח שברצונך למחוק את הפוסט?')) return
    try {
      await dispatch(removePost(postId)).unwrap()
      toast.success('הפוסט הוסר בהצלחה!')
      navigate('/')
    } catch (err) {
      toast.error(`שגיאה בהסרת הפוסט: ${err}`)
    }
  }

  const helpfulKey = `helpful-${postId}`
  const [helpfulState, setHelpfulState] = useState(
    utilService.getFromLocalStorage(helpfulKey) || null
  )

  useEffect(() => {
    const loadPost = async () => {
      setIsLoading(true)
      try {
        await dispatch(fetchPostById(postId)).unwrap()
      } catch (err) {
        console.error('❌ שגיאה בשליפת הפוסט:', err)
      } finally {
        setIsLoading(false)
      }
    }
    loadPost()
  }, [postId, dispatch])

  const handleToggleLike = async () => {
    if (!loggedInUser) {
      toast.error('יש להתחבר כדי לתת לייק')
      dispatch(openNotRegisteredPopup())
      return
    }
    const userId = loggedInUser._id || loggedInUser.uid
    if (!userId) {
      console.error('User ID is missing or invalid')
      return
    }
    try {
      await dispatch(toggleLike({ postId, userId }))
    } catch (err) {
      console.error('Failed to toggle like:', err)
      toast.error('שגיאה בעת ניסיון לתת לייק')
    }
  }

  const handleHelpful = async (type) => {
    try {
      // קריאה ל־Redux updateHelpful (ה־Controller מחשב את userId)
      const updatedPost = await dispatch(
        updateHelpful({ postId, type })
      ).unwrap()
      if (updatedPost) {
        setHelpfulState(type)
        if (!loggedInUser) {
          utilService.saveToLocalStorage(helpfulKey, type)
        }
      }
    } catch (err) {
      console.error('Failed to update helpful:', err)
      toast.error('שגיאה בעדכון הצבעה')
    }
  }

  if (isLoading) {
    return <Loader />
  }

  if (!selectedPost || !selectedPost._id) {
    return <p>⚠️ שגיאה: לא נמצא פוסט תואם.</p>
  }

  return (
    <div className="w-full mx-auto">
      <PostDetailsHelmet post={selectedPost} />
      {isEditing ? (
        <PostForm
          post={selectedPost}
          onSave={() => setIsEditing(false)}
          onCancel={() => setIsEditing(false)}
        />
      ) : (
        <>
        
          <PostDetailsMobileTop
            selectedPost={selectedPost}
            articelsHomePageImages={articelsHomePageImages}
            loggedInUser={loggedInUser}
            setIsEditing={setIsEditing}
            handleRemovePost={handleRemovePost}
          />
          <PostDetailsMobileFooter
            selectedPost={selectedPost}
            articelsHomePageImages={articelsHomePageImages}
            loggedInUser={loggedInUser}
            handleToggleLike={handleToggleLike}
          />
          <PostDetailsMainContent
            selectedPost={selectedPost}
            loggedInUser={loggedInUser}
            handleToggleLike={handleToggleLike}
            setIsEditing={setIsEditing}
            handleRemovePost={handleRemovePost}
          />
          <CommentIndex postId={postId} loggedInUser={loggedInUser} />

          <PostDetailsHelpfulSection
            selectedPost={selectedPost}
            helpfulState={helpfulState}
            handleHelpful={handleHelpful}
            articelsHomePageImages={articelsHomePageImages}
          />
          {/* <PostDetailsComments postId={postId} loggedInUser={loggedInUser} /> */}

          <div className="mx-auto container">
            <Articles />
          </div>
        </>
      )}
    </div>
  )
}
